import BaseCallUs from '../BaseCallUs';

const CallUs = () => {
  return <BaseCallUs subheader="Not ready to choose? Chat with an advisor, there’s absolutely no commitment." />;
};

export default CallUs;
